import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RouteService} from '../../shared/services/route.service';
import {Stop} from '../../shared/models/stop.model';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {BookingService} from '../../shared/services/booking.service';
import {FlightCreate} from '../../shared/models/flight.model';
import {ReservationCreate} from '../../shared/models/reservation.model';
import {PassengerCreate} from 'src/app/shared/models/passenger.model';
import {Router} from '@angular/router';
import {PaymentCreate} from '../../shared/models/payment.model';
import {forkJoin, Subject} from 'rxjs';
import {UserLogin} from '../../shared/models/user.model';
import {AuthenticationService} from '../../authentication/authentication.service';
import {PaymentService} from '../../shared/services/payment.service';
import {LogCreate} from '../../shared/models/log.model';
import {UserService} from '../../shared/services/user.service';
import {IntlTellInputService} from 'src/app/shared/services/intl-tell-input.service';
import {QrGeneratorService} from 'src/app/shared/services/qr-generator.service';
import {takeUntil, tap} from 'rxjs/operators';
import {SendEmailService} from '../../shared/services/send-email.service';
import {Observable} from 'rxjs/Rx';

@Component({
    selector: 'form-add-reservation',
    templateUrl: 'form-add-reservation.html'
})
export class FormAddReservationComponent implements OnInit, OnDestroy {

    bookingForm: FormGroup;

    stops: Stop[] = [];
    passengers: PassengerCreate[] = [];
    userId: string;
    bookingSummary: any = null;
    airportType = 'JFK';

    adult_num = 1;
    child_num = 0;
    infant_num = 0;

    selectConfig: any = {
        labelField: 'value',
        valueField: 'value',
        searchField: ['value']
    };

    modelDep;
    modelRe;

    date: { year: number, month: number };

    is_phone_valid: boolean;

    isValidTicket: boolean;
    isTriedSubmitted: boolean;

    // itinerarySummary: any = [];

    amount: number;
    agencyOptions: any = [];

    paymentCreate: PaymentCreate;
    is_on_check_payment: boolean;
    is_on_success_payment: boolean;

    is_on_process: boolean;
    errorMessage: String = '';
    is_on_success: boolean;
    is_on_fail: boolean;

    new_reservation_id: number;

    ipAddress: string;

    log_txt = '';

    user: UserLogin;

    is_on_success_step_one: boolean;

    /* Notice popup: true = booking is blocked until OK is pressed.
       Starts true so nothing can be submitted before the setting has loaded. */
    needsNoticeConfirm = true;
    /* Popup HTML from Settings > "Reservation Popup Notice". Empty = no popup. */
    noticeText = '';
    /* OK is enabled only after the notice has been scrolled to the end (or fits without scrolling). */
    noticeReadToEnd = false;
    /* Agreement checkbox must be ticked before OK is enabled. */
    noticeAgreed = false;
    @ViewChild('noticeBody') noticeBody: ElementRef;

    /* Notice snooze: after OK, hide the same notice for 48h for this user (localStorage).
       A changed notice text (different hash) shows the popup again before the 48h are up. */
    private readonly NOTICE_SNOOZE_MS = 48 * 60 * 60 * 1000;
    private noticeHash = '';

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private bookingService: BookingService,
                private paymentService: PaymentService,
                private router: Router,
                private authenticationService: AuthenticationService,
                private qrGeneratorService: QrGeneratorService,
                private sendEmailService: SendEmailService,
                private intlTellInputService: IntlTellInputService,
                private userService: UserService) {
        this.is_on_success_step_one = false;
        this.isValidTicket = true;
        this.is_phone_valid = false;
        this.is_on_check_payment = false;
        this.is_on_success_payment = false;
        this.is_on_process = false;
        this.isTriedSubmitted = false;
        this.amount = 0;
    }

    ngOnInit() {

        this.initBookingForm();

        this.bookingService.isValidTicketChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(
            (is_valid_ticket) => {
                this.isValidTicket = is_valid_ticket;
            }
        );

        this.bookingService.invoiceAmountChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.amount = value;
            }
        );

        this.intlTellInputService.tellChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.bookingForm.get('phone').setValue(value);
                this.is_phone_valid = true;
            }
        );

        this.intlTellInputService.isTellError
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                // put any value when error because not null
                this.bookingForm.get('phone').setValue('0');
                this.bookingForm.get('phone').markAsTouched();
                this.is_phone_valid = false;
            }
        );

        this.bookingService.submitFirst.pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.is_on_success_step_one = value;
            }
        );

        // payment success
        this.paymentService.paymentChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(
            (paymentCreate) => {
                this.is_on_check_payment = true;
                this.is_on_success_payment = true;
                this.paymentCreate = paymentCreate;
                this.submitReservation();
            }
        );

        // payment fail
        this.paymentService.isPaymentError.pipe(takeUntil(this.unsubscribe$)).subscribe(
            is_error => {
                if (is_error) {
                    this.is_on_process = false;
                    this.is_on_check_payment = true;
                    this.is_on_success_payment = false;
                    (<HTMLInputElement>document.getElementById('step-confirmation-previous-btn')).click();
                }
            }
        );

        this.dataStorageService.error.pipe(takeUntil(this.unsubscribe$)).subscribe(
            error => {
                if (error) {
                    this.errorMessage = error;
                }
            }
        );

        this.userService.setIPAddress().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
                this.ipAddress = res.ip;
            }
        );

        this.authenticationService.user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            this.user = user;
        });

        // Notice popup: load text from settings. No text -> no popup, booking allowed.
        this.dataStorageService.fetchSetting()
            .pipe(takeUntil(this.unsubscribe$)).subscribe(settings => {
            const text = settings && settings['text_notice_popup'] ? String(settings['text_notice_popup']).trim() : '';
            this.noticeText = text;
            this.noticeHash = this.hashNotice(text);
            // Show only when there is text AND it has not been confirmed within the last 48h.
            this.needsNoticeConfirm = text !== '' && !this.isNoticeSnoozed();
            // After the popup renders, enable OK right away if the text fits without scrolling.
            setTimeout(() => this.onNoticeScroll(), 0);
        }, () => {
            // If settings fail to load, don't lock the page.
            this.needsNoticeConfirm = false;
        });

    }

    /* go back to the first step */
    // resetForm() {
    //     // this.itinerarySummary = [];
    //     this.is_on_success_step_one = false;
    //     this.bookingService.resetInvoice();
    //     this.bookingService.resetDiscountInUse();
    // }


    /* Booking Form */

    initBookingForm() {
        this.bookingForm = new FormGroup({
            'email': new FormControl('', Validators.email),
            'phone': new FormControl(null
                , [Validators.required
                    , Validators.minLength(10)]),
            'is_paid_cash': new FormControl(),
            'payment_type': new FormControl('card'),
            'comment': new FormControl()
        });

        console.log(this.bookingForm);

        // this.getItinerarySummary();
    }
    onUserIdChanged(userId: string) {
        this.userId = userId;
    }

    /* Receive booking summary from the child routing form. */
    /* Receive booking summary from the child routing form. */
    onSummaryChanged(summary: any) {
        this.bookingSummary = summary;
    }

    /* Switch the airport; the bound input pushes it into the child routing form. */
    setAirportType(type: string) {
        this.airportType = type;
    }

    // getItinerarySummary() {
    //     const ticketDep = this.bookingService.getDepTicket();
    //     const ticketRe = this.bookingService.getReTicket();
    //     const routeDep = new RoutePipe(this.routeService).transform(ticketDep.route_id);
    //     this.itinerarySummary.push({
    //         'date': ticketDep.date,
    //         'stop': routeDep.pick_stop.title + ' - ' + routeDep.drop_stop.title,
    //         'time': routeDep.pick_time + ' - ' + routeDep.drop_time
    //     });
    //     if (ticketRe) {
    //         const routeRe = new RoutePipe(this.routeService).transform(ticketRe.route_id);
    //         this.itinerarySummary.push({
    //             'date': ticketRe.date,
    //             'stop': routeRe.pick_stop.title + ' - ' + routeRe.drop_stop.title,
    //             'time': routeRe.pick_time + ' - ' + routeRe.drop_time
    //         });
    //     }
    // }
    handlePaymentTypeChange(event: any) {
        if (this.user.level >= 3 && event.target.value === 'cash') {
            this.bookingForm.get('comment').setValue('Collect at the departure.');
        }
    }
    checkIsTriedSubmit() {
        /* step one check if valid */
        this.bookingService.setTicketsEmitter.emit();
        this.isTriedSubmitted = true;
    }

    checkIsTriedPay() {
        /* step one check if valid */
        this.bookingService.setTicketsEmitter.emit();
    }

    /* Notice popup: enable OK once the body is scrolled to the bottom (or has no scrollbar). */
    onNoticeScroll() {
        if (!this.noticeBody) { return; }
        const el = this.noticeBody.nativeElement;
        if (el.scrollHeight - el.scrollTop - el.clientHeight <= 4) {
            this.noticeReadToEnd = true;
        }
    }

    /* Notice popup: OK pressed -> hide popup, allow booking, remember for 48h. */
    onConfirmNotice() {
        if (!this.noticeReadToEnd || !this.noticeAgreed) { return; }
        this.needsNoticeConfirm = false;
        this.saveNoticeSnooze();
    }

    /* ---- Notice snooze helpers (per user, per notice content) ---- */

    private noticeStorageKey(): string {
        const uid = this.user && this.user.id ? this.user.id : 'anon';
        return 'ozNoticeOk_' + uid;
    }

    /* Small, stable string hash so a changed notice text invalidates the snooze. */
    private hashNotice(text: string): string {
        let h = 5381;
        for (let i = 0; i < text.length; i++) { h = ((h << 5) + h + text.charCodeAt(i)) | 0; }
        return String(h) + '_' + text.length;
    }

    private isNoticeSnoozed(): boolean {
        try {
            const raw = localStorage.getItem(this.noticeStorageKey());
            if (!raw) { return false; }
            const saved = JSON.parse(raw);
            if (!saved || saved.hash !== this.noticeHash) { return false; }   // notice changed -> show again
            return (Date.now() - Number(saved.at)) < this.NOTICE_SNOOZE_MS;   // within 48h of the OK click
        } catch (e) {
            return false;   // any storage problem -> show the popup (safe default)
        }
    }

    private saveNoticeSnooze() {
        try {
            localStorage.setItem(this.noticeStorageKey(),
                JSON.stringify({hash: this.noticeHash, at: Date.now()}));
        } catch (e) { /* storage unavailable -> popup simply shows next time */ }
    }


    /* Submit */

    onSubmit() {
        if (this.needsNoticeConfirm) { return; }
        this.is_on_process = true;
        this.is_on_success = false;
        this.is_on_fail = false;
        this.submitReservation();
    }

    onSubmitWithPayment() {
        if (this.needsNoticeConfirm) { return; }
        this.is_on_process = true;
        this.is_on_success = false;
        this.is_on_fail = false;
        if (this.bookingForm.get('payment_type').value === 'card') {
            this.paymentService.paymentProcessEmitter.emit();
        } else if (this.bookingForm.get('payment_type').value === 'cash') {
            this.submitReservation();
        }
    }

    submitReservation() {

        this.is_on_process = true;

        const discount_id = this.bookingService.getDiscountInUse() ? this.bookingService.getDiscountInUse().id : 0;


        const userIdForReservation = this.userId? +this.userId : this.user.id;

        const reservation = new ReservationCreate(userIdForReservation, discount_id, this.bookingForm.value.email
            , this.bookingForm.value.phone, this.bookingForm.value.comment, this.isValidTicket ? 1 : 0, 'confirmed');


        this.dataStorageService.createReservation(reservation)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
            if (responseData['error']) {
                this.errorMessage += 'saving reservation error. ';
                console.log('saving reservation error');
            } else {
                this.new_reservation_id = responseData.id;
                this.log_txt += 'Initial reservation #' + this.new_reservation_id + ' created. ';

                if (this.bookingForm.get('payment_type').value === 'cash' && this.bookingForm.get('is_paid_cash').value) {
                    this.submitPayment(responseData.id, 'cash').then(() => {
                        this.submitPassengerAndTicket(responseData.id);
                    });
                } else if (this.is_on_success_payment) {
                    this.submitPayment(responseData.id, 'card').then(() => {
                        this.submitPassengerAndTicket(responseData.id);
                    }, error => {
                        alert('Payment information has not been saved. Please close all tabs and try again. ');
                    });
                } else {
                    this.submitPassengerAndTicket(responseData.id);
                }
            }
        });

    }

    submitPayment(reservation_id: number, type: string) {
        if (type === 'card') {
            this.paymentCreate.reservation_id = reservation_id;
            this.paymentCreate.user_id = this.user.id;
            return new Promise(resolve => {
                this.dataStorageService.createPayment(this.paymentCreate)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                    responseData => {
                        if (responseData['error']) {
                            this.errorMessage += 'saving payment error. ';
                            resolve(false);
                        } else {
                            this.log_txt += 'Payment information $' + this.paymentCreate.amount
                                + ', #' + this.paymentCreate.square_payment_id + ' created. ';
                            resolve(true);
                        }
                    }
                );
            });
        } else if (type === 'cash') {
            const paymentCreate = new PaymentCreate(reservation_id, this.user.id, this.amount
                , 'Cash', null, null, null, null);
            return new Promise(resolve => {
                this.dataStorageService.createPayment(paymentCreate)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                    responseData => {
                        if (responseData['error']) {
                            this.errorMessage += 'saving payment error. ';
                            resolve(false);
                        } else {
                            this.log_txt += 'Payment information Cash $' + paymentCreate.amount + ' created. ';
                            resolve(true);
                        }
                    }
                );
            });
        }
    }

    submitPassengerAndTicket(reservation_id: number) {
        this.submitPassenger(reservation_id).then(() => {
            this.submitTicket(reservation_id).then(() => {
                this.checkError();
            });
        });
    }

    submitPassenger(reservation_id: number) {

        const passengerAdultsValue = this.bookingService.getPassengerAdultsValue();
        const passengerChildrenValue = this.bookingService.getPassengerChildrenValue();
        const passengerInfantsValue = this.bookingService.getPassengerInfantsValue();
        const passengersValue = [...passengerAdultsValue, ...passengerChildrenValue,...passengerInfantsValue];
        // console.log(passengerAdultsValue);

        const passengerAdultsArr: PassengerCreate[] = [];
        const passengerChildrenArr: PassengerCreate[] = [];
        const passengerInfantsArr: PassengerCreate[] = [];
        let passengersArr: PassengerCreate[] = [];

        return new Promise(resolve => {

            if (passengerAdultsValue) {
                for (const passengerAdultValue of passengerAdultsValue) {
                    const passengerAdult = new PassengerCreate(
                        passengerAdultValue.first_name,
                        passengerAdultValue.last_name, 'Adult', reservation_id);
                    passengerAdultsArr.push(passengerAdult);
                }
            }
            if (passengerChildrenValue) {
                for (const passengerChildValue of passengerChildrenValue) {
                    const passengerChild = new PassengerCreate(
                        passengerChildValue.first_name,
                        passengerChildValue.last_name, 'Child', reservation_id);
                    passengerChildrenArr.push(passengerChild);
                }
            }
            if (passengerInfantsValue) {
                for (const passengerInfantValue of passengerInfantsValue) {
                    const passengerInfant = new PassengerCreate(
                        passengerInfantValue.first_name,
                        passengerInfantValue.last_name, 'Infant', reservation_id);
                    passengerInfantsArr.push(passengerInfant);
                }
            }
            passengersArr = [...passengerAdultsArr, ...passengerChildrenArr, ...passengerInfantsArr];
            this.dataStorageService.createPassengers(passengersArr)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                if (responseData['error']) {
                    this.errorMessage += 'saving passengers error. ';
                    console.log('saving passengers error');
                } else {
                    for (let i = 0; i < passengersArr.length; i++) {
                        this.log_txt += 'Passenger information ' + passengersArr[i].last_name + '/' + passengersArr[i].first_name + 'created. ';
                        if (this.isValidTicket) {
                            // TODO: make it create by group
                            this.submitFlight(responseData['ids'][i], passengersValue[i].ticket_no);
                        }
                    }
                    resolve(true);
                }
            });
        });
    }

    submitFlight(passenger_id: number, ticket_no: number) {
        const pnr = this.bookingService.getPnr();
        const flight = new FlightCreate(passenger_id, ticket_no, pnr);
        this.dataStorageService.createFlight(flight)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    this.errorMessage += 'saving flight error. ';
                    console.log('saving flight error');
                } else {
                    this.log_txt += 'Flight information for pax #' + passenger_id + ' ' + pnr + '/' + ticket_no + 'created. ';
                }
            }
        );
    }

    submitTicket(reservation_id: number) {

        const ticketDep = this.bookingService.getDepTicket();

        return new Promise(resolve => {
            ticketDep.reservation_id = reservation_id;
            this.dataStorageService.createTicket(ticketDep)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        this.errorMessage += 'saving departure schedule error';
                        console.log('saving departure schedule error');
                    } else {
                        this.addBlockDateAfterCheck(ticketDep.date, ticketDep.route_id);
                        this.log_txt += 'Departure Ticket information ' + ticketDep.date + ' ' + ticketDep.route_id + 'created. ';

                        // Add return
                        const is_round_trip = this.bookingService.getIsRoundTrip();
                        if (is_round_trip) {
                            const ticketRe = this.bookingService.getReTicket();
                            ticketRe.reservation_id = reservation_id;
                            // console.log(ticketRe);
                            this.dataStorageService.createTicket(ticketRe)
                                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                                responseDataRe => {
                                    if (responseDataRe['error']) {
                                        this.errorMessage += 'saving return schedule error';
                                        console.log('saving return schedule error');
                                    } else {
                                        this.addBlockDateAfterCheck(ticketRe.date, ticketRe.route_id);
                                        this.log_txt += 'Return Ticket information '
                                            + ticketRe.date + ' ' + ticketRe.route_id + 'created. ';
                                        resolve(true);
                                    }
                                }
                            );
                        } else {
                            resolve(true);
                        }
                    }
                }
            );
        });

    }


    /* Add Block Date if exceed */
    addBlockDateAfterCheck(date: string, route_id: number) {
        const dispatch_group_id = this.routeService.getDispatchGroupIdByRouteId(route_id);
        this.dataStorageService.addBlockDateAfterCheck(date, dispatch_group_id, this.adult_num + this.child_num+ this.infant_num);
    }


    /* Check Success */

    checkError() {
        this.is_on_process = false;
        if (this.errorMessage === '' && this.new_reservation_id) {
            this.is_on_success = true;
            this.onSuccess(this.new_reservation_id);
        } else {
            this.is_on_fail = true;
        }
    }


    /* Success & Confirmation */

    onSuccess(reservation_id) {
        // save qr
        this.qrGeneratorService.getQrImg(reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            response => {
                if (response['error']) {
                    alert('qr code error. ');
                } else {
                    const qrid = response.qrid;
                    this.dataStorageService.updateReservationQr(qrid, reservation_id)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(
                        res => {
                            if (res['error']) {
                                alert('qr code update error. ');
                            }
                            // save log
                            const newLog = new LogCreate(this.user.id, 'Initial reservation created. ', this.ipAddress);
                            newLog.reservation_id = reservation_id;
                            this.dataStorageService.createLog(newLog)
                                .pipe(takeUntil(this.unsubscribe$))
                                .subscribe(responseData => {
                                    // send confirmation email.
                                    this.onSendEmail(reservation_id);
                                });
                        }
                    );
                }
            });

    }

    onSendEmail(reservation_id: number) {
        this.dataStorageService.fetchReservation(reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            reservation => {
                const emailObj = {
                    type: 1,
                    email_to: reservation.email,
                    reservation: reservation
                };
                this.sendEmailService.initEmail(emailObj);
                setTimeout(() => {
                    // go to coupon page
                    this.onLoadCoupon(reservation_id);
                }, 1000);
            }
        );

    }

    onLoadCoupon(reservation_id) {
        this.router.navigate(['/extras/coupon', reservation_id]);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();

        this.is_on_success_step_one = false;
        this.isValidTicket = true;
        this.is_phone_valid = false;
        this.is_on_check_payment = false;
        this.is_on_success_payment = false;
        this.is_on_process = false;
        this.isTriedSubmitted = false;
    }

}
